// @flow

import React from "react";
import { connect } from "react-redux";

import { updateStep, toggleIndicator } from "@src/actions";

import Toggle from "material-ui/Toggle";
import { muiToggleStyle } from "@src/common/theme";

import { Button, Dialog, Flex, Text } from "@src/common";
import { TextAreaInput } from "@src/common/textInput";
import { UL, LI } from "@src/components";

import {
  RiskIndicatorDialog,
  RiskIndicatorsDialogBody,
  RiskIndicatorsDialogHeader
} from "./components";

import {
  Behaviour,
  BehaviourToggleRightLabel,
  Comment
} from "@src/containers/Assessment/components";
import { ContentBody, ContentHeader } from "@src/components";

import { printPdf, downloadPdf } from "@src/pdf/documentTemplate";

const renderBehaviours = (
  behaviour,
  behaviourIndex,
  activeSubStep,
  behaviourKey,
  toggleIndicator
) => {
  return (
    <Behaviour key={behaviourIndex}>
      <Text type="bold" size="4">
        {behaviour.text}:
      </Text>
      <UL>
        {behaviour.points.map((point, index) => (
          <LI key={index}>
            <Text type="book" size="5">
              {point}
            </Text>
          </LI>
        ))}
      </UL>
      <Flex
        justifyContent="flex-end"
        style={{ cursor: "pointer" }}
        onClick={() => toggleIndicator(activeSubStep, behaviourKey)}
      >
        <Toggle
          key={`${behaviourKey + behaviourIndex}`}
          label="No"
          toggled={behaviour.checked}
          style={muiToggleStyle.style}
          labelStyle={muiToggleStyle.label}
        />
        <BehaviourToggleRightLabel>Yes</BehaviourToggleRightLabel>
      </Flex>
    </Behaviour>
  );
};

class RiskIndicators extends React.Component {
  render() {
    const {
      activeStep,
      activeSubStep,
      careTypeTitle,
      disabledCompleteOnStageA,
      enableCompleteOnStageA,
      riskColor,
      riskTypeText,
      section,
      showConfirmDialog,
      toggleIndicator,
      appState
    } = this.props;

    const riskScore = appState.riskScore;

    // Sub section
    let { title, behaviours } = section.subsections[activeSubStep];

    return (
      <Flex justifyContent="flex-start" flexDirection="column">
        <Dialog
          display={showConfirmDialog}
          onClickOnBlur={this.props.hideConfirmDialog}
        >
          <RiskIndicatorDialog>
            <RiskIndicatorsDialogHeader backgroundColor={riskColor}>
              <Text
                type="bold"
                size={3}
                color={riskScore && riskScore > 1 ? "white" : "black"}
              >
                {careTypeTitle} - Risk Rating: {riskTypeText}
              </Text>
            </RiskIndicatorsDialogHeader>
            <RiskIndicatorsDialogBody>
              <Text
                type="bold"
                size={3}
                color="maroon"
                style={{ textAlign: "center", width: "100%" }}
                marginT={4}
              >
                This Assessment is marked as complete.
                <br />
                Would you like to print it now?
              </Text>
              <Text
                type="book"
                size={4}
                color="maroon"
                padding={5}
                style={{ width: "100%" }}
              >
                Continue to the Overall Risk Rating and Contributing Factors Sections if you wish to identify control measures that can be put in place to minimize the risk this client will become violent, aggressive or present a responsive behaviour.
              </Text>
              <Flex marginB={4}>
                <Button
                  secondary
                  medium
                  marginH={2}
                  onClick={this.props.hideConfirmDialog}
                >
                  Close
                </Button>
                <Button medium marginH={2} onClick={() => printPdf(appState)}>
                  Print
                </Button>
                <Button
                  medium
                  marginH={2}
                  onClick={() => downloadPdf(appState)}
                >
                  Download PDF
                </Button>
                <Button
                  medium
                  marginH={2}
                  onClick={() => {
                    this.setState({ showConfirmDialog: false }, () => {
                      this.props.updateStep({
                        activeStep: activeStep + 1,
                        activeSubStep: 0
                      });
                    });
                  }}
                >
                  Continue to Risk Rating
                </Button>
              </Flex>
            </RiskIndicatorsDialogBody>
          </RiskIndicatorDialog>
        </Dialog>
        <ContentHeader backgroundColor="whiteGrey">
          <Text size={4} type="bold">
            {activeSubStep + 1}. {title}
          </Text>
        </ContentHeader>
        <ContentBody
          onScroll={e => {
            if (disabledCompleteOnStageA) {
              if (
                e.target.offsetHeight + e.target.scrollTop >=
                e.target.scrollHeight - 100
              ) {
                enableCompleteOnStageA();
              }
            }
          }}
        >
          {Object.keys(behaviours).map((behaviourKey, index) =>
            renderBehaviours(
              behaviours[behaviourKey],
              index,
              activeSubStep,
              behaviourKey,
              toggleIndicator
            )
          )}
          <Comment>
            <TextAreaInput
              placeholder="Add a comment"
              onChange={this.props.onCommentChange}
              value={this.props.commentValue}
            />
          </Comment>
        </ContentBody>
      </Flex>
    );
  }
}

function mapStateToProps(store) {
  return {
    appState: store.app
  };
}

function mapDispatchToProps(dispatch) {
  return {
    toggleIndicator: (activeSubStep, behaviourKey) =>
      dispatch(toggleIndicator(activeSubStep, behaviourKey)),
    updateStep: args => dispatch(updateStep(args))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RiskIndicators);



// WEBPACK FOOTER //
// ./src/containers/Assessment/ContentWrapper/Layouts/RiskIndicators.jsx